import { useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { storage } from '../../../utils';
import { BoomStorageKeyTypes, getBoomStorageValue } from '../constants/storage';
import { selectBoomGlobalBoomId } from '../selectors/global/globalPrimary.selector';
import { selectIsBoomPlayable } from '../selectors/runtime.selector';

const useBoomWelcomePopupUtils = (): [boolean, (value: boolean) => void] => {
  const boomId = useSelector(selectBoomGlobalBoomId);
  const key = boomId ? getBoomStorageValue(boomId, BoomStorageKeyTypes.WELCOME_BEEN_VIEWED) : null;
  const hasBeenViewed = key ? storage.localStorage.load(key) : false;
  const [viewed, setViewed] = useState(hasBeenViewed);
  const setHasBeenViewed = useCallback(
    (value: boolean) => {
      if (key) {
        storage.localStorage.save(key, value);
        setViewed(true);
      }
    },
    [key],
  );

  const isBoomPlayable = useSelector(selectIsBoomPlayable);
  const shouldShow = useMemo(() => !viewed && isBoomPlayable, [viewed, isBoomPlayable]);

  return [shouldShow, setHasBeenViewed];
};

export default useBoomWelcomePopupUtils;
